import React, { useEffect, useState } from "react";
import { BsTelephone } from "react-icons/bs";
import { CiLocationOn } from "react-icons/ci";
import { MdDeliveryDining, MdOutlineCancel } from "react-icons/md";
import { IoCheckmarkDoneCircleOutline } from "react-icons/io5";
import { RiProgress2Fill } from "react-icons/ri";
import { SlCheck } from "react-icons/sl";
import { useSelector } from "react-redux";
import moment from "moment";
import "../../../../Assets/css/tailwind.css";
import { formattedAmount } from "../../../../utils/helpers/Functions.helper";
import DropdownMenubar from "../../../../Components/Menubar/DropdownMenubar";
import { Badge } from "primereact/badge";
import { toast } from "react-toastify";
import OrderApi from "../../../../App/api/order.apis";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { FcShop } from "react-icons/fc";
import PrintInvoice from "./PrintInvoice";

function OrderDetails({
  deliveryAddress,
  orderDetails,
  orderData,
  handleCloseOrderModal,
  OrderDataFun,
}) {
  const { theme } = useSelector((state) => state.theme);
  const [count, setCount] = useState(false);

  const handleAction = async (data, action) => {
    console.log("data", data);
    console.log("action", action);

    
    if (action.vendor_action) {
      const payload = {
        orderId: data._id,
        vendor_action: action.vendor_action,
      };
      try {
        await OrderApi.updateOrders(payload);

        toast.success(`Order Updated Successfully`);
        setCount(!count);
        handleCloseOrderModal();
        OrderDataFun();
      } catch (error) {
        console.log(error);
      }
    }
  };
  useEffect(() => {
    OrderDataFun();
  }, [count]);

 
  return (
    <div
      className={`p-6 mx-auto rounded-lg shadow-md transition-all duration-300 ease-in-out ${
        theme === "light"
          ? "bg-white text-gray-800"
          : "bg-darkThirsary text-darkSecondary"
      }`}
    >
      <div className="mb-6 border-b border-gray-300 pb-4">
        <div className="flex justify-between items-center">
          <div>
            <p className="text-sm font-medium">
              Invoice #{orderData?.order_id} -{" "}
              {moment(deliveryAddress?.createdAt).format("DD MMM YYYY hh:mm A")}
            </p>
            <p>
              Payment status:{" "}
              <span
                className={`text-sm ${
                  orderData?.payment_status === "UNPAID"
                    ? "text-red-500"
                    : "text-green-500"
                }`}
              >
                {orderData?.payment_status}
              </span>
            </p>

            <p className="text-sm text-gray-500">
              Payment type {orderData?.pay_type}
            </p>
          </div>
          <div className="bg-blue-900 text-white px-4 py-2 rounded-md text-sm text-center shadow">
            <p>{orderData?.delivery_status}</p>
            <p>
              {moment(deliveryAddress?.updatedAt).format("DD MMM YYYY hh:mm A")}
            </p>
          </div>
        </div>
      </div>

      <div className="mb-6">
        <h3 className="font-semibold mb-2 text-lg">Order by</h3>
        <p className="text-xl font-semibold hover:text-blue-900 transition duration-300">
          {deliveryAddress?.name ?? "N/A"}
        </p>
        <div className="flex justify-between items-center mt-1">
          <p className="text-gray-500 text-xl hover:text-blue-900 transition duration-300">
            {deliveryAddress?.phone_number ?? "N/A"}
          </p>
          <BsTelephone className="text-2xl text-blue-900 hover:text-blue-700 transition duration-300" />
        </div>

        <div className="flex items-center p-2 gap-4 mt-4  rounded-lg shadow-sm">
          <CiLocationOn className={`text-3xl ${theme?"text-blue-900":"text-gray-200"}`} />
          <p className="">
            {deliveryAddress?.flat_no ?? "N/A"},{" "}
            {deliveryAddress?.landmark ?? "N/A"},
            {deliveryAddress?.street ?? "N/A"},{" "}
            {deliveryAddress?.pin_code ?? "N/A"}
          </p>
        </div>
      
      </div>
      <div
        className={`p-6 rounded-lg shadow-lg max-w-lg mx-auto transition-all duration-300 ${
          theme === "light"
            ? "bg-secondaryColor text-textColorLight"
            : "bg-darkThirsary text-darkSecondary"
        }`}
      ></div>
      <hr className="my-4 border-gray-300" />
      {orderDetails.map((details, index) => (
        <div
          key={index}
          className="mb-6 p-4  rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200"
        >
          {/* {JSON.stringify(details?.product?.product_details)} */}
          <div className="flex justify-between items-center">
            <div className="w-fit flex justify-center items-center gap-2">
              <div className="overflow-hidden">
                {details?.vendor?.profile_image ? (
                  <LazyLoadImage
                    src={details?.vendor?.profile_image}
                    alt="img"
                    loading="lazy"
                    effect="blur"
                    wrapperProps={{
                      style: { transitionDelay: "1s" },
                    }}
                    className="rounded-sm w-20 h-20"
                  />
                ) : (
                  <div className="rounded-sm w-20 h-20 bg-[#d2d2d2] flex justify-center items-center">
                    <FcShop className="text-[3rem]  text-[#02aabd93]" />
                  </div>
                )}
              </div>
              <h3 className="font-bold text-xl">
                {details?.vendor?.first_name || ""}
              </h3>
            </div>
            <div>
              <GetVendorInfo row={details} handleAction={handleAction} />
            </div>
          </div>

          <hr className="my-4 border-gray-300" />
          <div className="flex justify-between items-center">
            <h3 className="font-bold text-lg ">
              {details?.product?.name ?? "Unnamed Product"}
            </h3>
          </div>

          <div className="flex justify-between items-center mb-4 mt-2">
            <p className={`${theme?"text-blue-900":"text-blue-200"} font-semibold`}>
              Quantity {details?.quantity ?? 0}
              {(details?.quantity ?? 0) > 1 ? "s" : ""}
            </p>
          </div>
          <div className="flex justify-between items-center mb-4 mt-2">
            <p className={`${theme?"text-blue-900":"text-blue-200"} font-semibold`}>
              Price{" "}
              {formattedAmount(
                +details?.product?.taxData?.grandTotal?.$numberDecimal ||
                  +details?.product?.taxData?.grandTotal
              )}
            </p>
          </div>
          <div className="flex justify-between items-center mb-4 mt-2">
            <p className={`${theme?"text-blue-900":"text-blue-200"} font-semibold`}>
              Delivery Charge{" "}
              {formattedAmount(
                Number(details?.delivery_fee?.totalDeliveryFee ?? 0)
              )}
            </p>
          </div>

          <div className="flex justify-between items-center">
            <p className="text-green-600 text-lg font-semibold">
              Net Total{" "}
              {formattedAmount(
                (+details?.product?.taxData?.grandTotal?.$numberDecimal ||
                  +details?.product?.taxData?.grandTotal) *
                  +details?.quantity +
                  +details?.delivery_fee?.totalDeliveryFee
              )}
            </p>
            <OrderStatus row={details} />
          </div>
          <hr className="mt-2 border-gray-300" />
          <PrintInvoice
            details={details}
            deliveryDetails={deliveryAddress}
            vendorDetails={details.vendor}
            index={index}
          />
      
        </div>
      ))}
    </div>
  );
}

export default OrderDetails;

const OrderStatus = ({ row }) => {
  let severity;
  if (row.delivery_status === "DELIVERED") {
    severity = "success";
  } else if (row.delivery_status === "WAITING") {
    severity = "warning";
  } else if (row.delivery_status === "ACCEPTED") {
    severity = "success";
  } else if (row.delivery_status === "CANCELLED") {
    severity = "danger";
  }

  return row.delivery_status ? (
    <Badge
      className="w-[9rem]"
      severity={severity}
      value={row.delivery_status}
    />
  ) : null;
};

const DD = ({ MenuItems }) => {
  return (
    <div className="w-[1.5rem] h-[1.5rem] rounded-sm flex justify-center items-center">
      <DropdownMenubar
        menuItem={[
          {
            label: "Action",
            items: MenuItems,
          },
        ]}
      />
    </div>
  );
};
const GetVendorInfo = ({ row, handleAction }) => {
  // console.log("Get Status",row);

  const status = row?.delivery_status;
  switch (status) {
    case "WAITING":
      return (
        <DD
          MenuItems={[
            {
              label: "ACCEPT",
              icon: <SlCheck style={{ color: " rgb(15 61 100)" }} />,
              command: () => {
                // console.log("Accept", row);
                handleAction && handleAction(row, { vendor_action: "ACCEPT" });
              },
            },
            {
              label: "REJECT",
              icon: <MdOutlineCancel style={{ color: " rgb(15 61 100)" }} />,
              command: () => {
                // console.log("Reject", row);
                handleAction && handleAction(row, { vendor_action: "REJECT" });
              },
            },
          ]}
        />
      );
    case "REJECTED":
      return <>Rejected</>;
    case "ACCEPTED":
      return (
        <DD
          MenuItems={[
            {
              label: "DELIVERED",
              icon: <RiProgress2Fill style={{ color: " rgb(15 61 100)" }} />,
              command: () => {
                // console.log("ASSIGN", row);
                handleAction &&
                  handleAction(row, { vendor_action: "DELIVERED" });
              },
            },
            {
              label: "CANCEL",
              icon: <MdOutlineCancel style={{ color: " rgb(15 61 100)" }} />,
              command: () => {
                // console.log("CANCEL", row);
                handleAction && handleAction(row, { vendor_action: "CANCEL" });
              },
            },
          ]}
        />
      );
    case "PREPARED":
      return (
        <DD
          MenuItems={[
            {
              label: "READY",
              icon: (
                <IoCheckmarkDoneCircleOutline
                  style={{ color: " rgb(15 61 100)" }}
                />
              ),
              command: () => {
                // console.log("Accept", row);
                handleAction && handleAction(row, { vendor_action: "READY" });
              },
            },
            {
              label: "CANCEL",
              icon: <MdOutlineCancel style={{ color: " rgb(15 61 100)" }} />,
              command: () => {
                // console.log("CANCEL", row);
                handleAction && handleAction(row, { vendor_action: "CANCEL" });
              },
            },
          ]}
        />
      );
    case "READY":
      return (
        <DD
          MenuItems={[
            {
              label: "ASSIGN",
              icon: <MdDeliveryDining style={{ color: " rgb(15 61 100)" }} />,
              command: () => {
                // console.log("Accept");
                handleAction && handleAction(row, { vendor_action: "ASSIGN" });
              },
            },
            {
              label: "CANCEL",
              icon: <MdOutlineCancel style={{ color: " rgb(15 61 100)" }} />,
              command: () => {
                // console.log("CANCEL");
                handleAction && handleAction(row, { vendor_action: "CANCEL" });
              },
            },
          ]}
        />
      );
    case "ASSIGNED":
      return (
        <DD
          MenuItems={[
            {
              label: "DELIVERED",
              icon: <MdDeliveryDining style={{ color: " rgb(15 61 100)" }} />,
              command: () => {
                // console.log("Accept");
                handleAction &&
                  handleAction(row, { vendor_action: "DELIVERED" });
              },
            },
            {
              label: "CANCEL",
              icon: <MdOutlineCancel style={{ color: " rgb(15 61 100)" }} />,
              command: () => {
                // console.log("CANCEL");
                handleAction && handleAction(row, { vendor_action: "CANCEL" });
              },
            },
          ]}
        />
      );
    default:
      return <></>;
  }
};
